import { PageTitle } from '_metronic/layout/core'

import ButtonFilter from 'Presentation/Components/ButtonFilter'
import Select from 'react-select'
import { ClientSideTable } from 'Presentation/Components/Table'

import useViewModel from './ViewModel'
import clsx from 'clsx'
import { isMobileDevice } from '_metronic/assets/ts/_utils'

//////////
// View //
//////////

const CertificationView: React.FC = () => {
	const { filters, onClickFilter, data, TABLE_CONFIGS } = useViewModel()
	const isMobile = isMobileDevice()

	return (
		<ViewPageTitle>
			<div className="row gy-5">
				{/* Button Filter */}
				<div className="d-none d-xl-block col-12">
					<ButtonFilter buttons={filters} onClick={onClickFilter} />
				</div>
				<div className="d-none d-xl-block col-12">
					<div className="separator border-kumopack-grey-200" />
				</div>

				{/* Dropdown Select */}
				<div className="d-block d-xl-none col-12">
					<Select
						isSearchable={false}
						defaultValue={{ value: 4, label: filters[4].label }}
						options={filters.map((tab, idx) => ({ value: idx, label: tab.label }))}
						styles={{
							control: (baseStyles, state) => ({
								...baseStyles,
								border: '1px solid #e1e3ea',
								borderRadius: 8,
							}),
						}}
					/>
				</div>

				<div className="col-12">
					<div className="card border border-kumopack-grey-200">
						<div className="card-header border-kumopack-grey-200 mt-4">
							<div
								className={clsx('card-title', {
									'w-100': isMobile,
								})}>
								{/* Button Group */}
								<div className="d-none d-xl-flex kumopack-button-group">
									<button className="btn btn-sm white-button left">View All</button>
									<button className="btn btn-sm white-button middle">Parent Product</button>
									<button className="btn btn-sm white-button right">Child Product</button>
								</div>

								{/* Select */}
								<Select
									className="w-100 d-block d-xl-none"
									isSearchable={false}
									defaultValue={{
										label: 'View All',
										value: 'view-all',
									}}
									options={[
										{
											label: 'View All',
											value: 'view-all',
										},
										{
											label: 'Parent Product',
											value: 'parent-product',
										},
										{
											label: 'Child Product',
											value: 'child-product',
										},
									]}
									styles={{
										control: (baseStyles, state) => ({
											...baseStyles,
											border: '1px solid #e1e3ea',
											borderRadius: 8,
											fontSize: isMobile ? '12px' : '14px',
										}),
										option: (baseStyles, state) => ({
											...baseStyles,
											fontSize: isMobile ? '12px' : '14px',
										}),
									}}
								/>
							</div>

							<div
								className={clsx('card-toolbar', {
									'w-50': !isMobile,
									'w-100': isMobile,
								})}>
								<div
									className="d-flex flex-column flex-xl-row align-items-center w-100 justify-content-end"
									style={{ gap: '12px' }}>
									<div
										className={clsx('position-relative', {
											'w-100': isMobile,
											'w-75': !isMobile,
										})}>
										<input
											className="form-control form-control-sm"
											placeholder="Search"
											style={{ paddingLeft: '3rem' }}
										/>
										<img
											className="position-absolute pointer-events-none"
											src="/media/icons/kumopack/search-lg.svg"
											alt="Large Search Icon"
											style={{ top: '20%', left: '1rem' }}
										/>
									</div>
									<button
										className={clsx('btn btn-sm white-button text-kumopack-grey-700 fw-bold', {
											'w-100': isMobile,
										})}>
										<img
											className="me-1"
											src="/media/icons/kumopack/filter-lines.svg"
											alt="Filter Line Icon"
										/>
										Filters
									</button>
								</div>
							</div>
						</div>

						<div className="card-body px-0">
							<ClientSideTable pagination items_per_page={10} columns={TABLE_CONFIGS} data={data} />
						</div>
					</div>
				</div>
			</div>
		</ViewPageTitle>
	)
}

/////////////////////
// View Page Title //
/////////////////////

const ViewPageTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<>
			<PageTitle
				breadcrumbs={[
					{
						title: 'General',
						path: '/general',
						isActive: false,
						isSeparator: false,
					},
					{
						title: 'Certification',
						path: '#',
						isActive: true,
						isSeparator: false,
					},
				]}>
				Certification Options
			</PageTitle>

			{children}
		</>
	)
}

export default CertificationView
